module.exports = __webpack_public_path__ + "img/source.92e616ce.png";